
<div class="wrapper" [ngClass]="{'h-screen grid' : !show()}">
  <app-content-header-edit [id]="id()" [isViewOnly]="isViewOnly()" [invalid]="formGroup.invalid"
    [hasPermissionEdit]="hasPermissionEdit()" [title]="title()" (save)="save()" (cancel)="cancel()"
    (toggleEdit)="toggleEdit()" [instance]="instance"></app-content-header-edit>
  @if(show()) {
  @if(!isViewOnly() || !id()) {
  <div class="p-4" [ngClass]="{ 'mt-1' : instance }" [formGroup]="formGroup">
    <div class="flex flex-wrap mt-2 mb-6">
      @if(!instance) {
        <div class="pr-2 pb-6 sm:w-6/12 w-full">
          <p-floatLabel>
            <input pInputText type="text" placeholder="" class="w-full" formControlName="entityID" />
            <label>Entity <span class="text-red-600">*</span></label>
          </p-floatLabel>
          <app-validation-feedback [control]="entityIDControl()" [errors]="entityIDControl().errors"></app-validation-feedback>
        </div>
        <div class="pr-2 pb-6 sm:w-6/12 w-full">
          <p-floatLabel>
            <input pInputText type="text" placeholder="" class="w-full" formControlName="entityType" />
            <label class="w-100">Entity Type <span class="text-red-600">*</span></label>
          </p-floatLabel>
          <app-validation-feedback [control]="entityTypeControl()" [errors]="entityTypeControl().errors"></app-validation-feedback>
        </div>
      }
      <div class="pr-2 pb-6 sm:w-6/12 w-full">
        <p-floatLabel>
          <p-dropdown styleClass="w-full" formControlName="category" [options]="categorys" optionValue="id"
            optionLabel="description" placeholder="" (onChange)="selectSubCategories($event.value)"></p-dropdown>
          <label class="w-100">Category <span class="text-red-600">*</span></label>
        </p-floatLabel>
        <app-validation-feedback [control]="categoryControl()" [errors]="categoryControl().errors"></app-validation-feedback>
      </div>
      <div class="pr-2 pb-6 sm:w-6/12 w-full">
        <p-floatLabel>
          <p-dropdown styleClass="w-full" formControlName="subCategory" [options]="subCategories" optionValue="id"
            optionLabel="description" placeholder=""></p-dropdown>
          <label class="w-100">SubCategory <span class="text-red-600">*</span></label>
        </p-floatLabel>
        <app-validation-feedback [control]="subCategoryControl()" [errors]="subCategoryControl().errors"></app-validation-feedback>
      </div>
      <div class="pr-2 pb-6 sm:w-6/12 w-full">
        <p-floatLabel>
          <textarea rows="5" pInputText type="text" placeholder="Content" class="w-full" formControlName="content"></textarea>
          <label class="w-100">Content <span class="text-red-600">*</span></label>
        </p-floatLabel>
        <app-validation-feedback [control]="contentControl()" [errors]="contentControl().errors"></app-validation-feedback>
      </div>
    </div>
  </div>
  }
  @else {
    @if(dataList.length > 0) {
      <app-view [dataList]="dataList"></app-view>
    }
  }
  }
  @else {
  <div class="flex justify-center items-center w-full m-auto">
    <p-progressSpinner ariaLabel="loading" styleClass="m-auto" />
  </div>
  }
  <p-toast appendTo="body" />
</div>
